import React from "react";

const CHART = {
  women: {
    cols: ["Size", "Bust", "Underbust", "Waist", "Hips"],
    rows: [
      ["XS", "78–82", "63–67", "60–64", "86–90"],
      ["S", "82–86", "67–71", "64–68", "90–94"],
      ["M", "86–90", "71–75", "68–72", "94–98"],
      ["L", "90–95", "75–80", "72–77", "98–103"],
      ["XL", "95–101", "80–86", "77–83", "103–109"],
    ],
  },
  men: {
    cols: ["Size", "Chest", "Waist", "Hips"],
    rows: [
      ["XS", "86–91", "71–76", "86–91"],
      ["S", "91–97", "76–81", "91–97"],
      ["M", "97–102", "81–86", "97–102"],
      ["L", "102–108", "86–92", "102–108"],
      ["XL", "108–114", "92–98", "108–114"],
    ],
  },
};

const norm = (s) => (s || "").toUpperCase().replace(/[^A-Z]/g, "").slice(0, 2);

export const SizeChart = ({ gender = "women", highlight }) => {
  const data = CHART[gender] || CHART.women;
  const hi = norm(highlight);
  return (
    <div data-testid="size-chart" className="overflow-x-auto border border-charcoal/10 rounded-2xl bg-white">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-charcoal/10 text-left">
            {data.cols.map((c, i) => (
              <th key={c} className={`p-3 overline text-charcoal/55 ${i === 0 ? "" : "text-right"}`}>
                {c}{i > 0 ? " (cm)" : ""}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.rows.map((r) => {
            const active = norm(r[0]) === hi;
            return (
              <tr
                key={r[0]}
                data-testid={`size-row-${r[0]}`}
                className={`border-b border-charcoal/5 transition-colors ${active ? "bg-sunkissed/20" : ""}`}
              >
                {r.map((cell, i) => (
                  <td key={i} className={`p-3 ${i === 0 ? "font-medium" : "text-right text-charcoal/70"}`}>
                    <span className="inline-flex items-center gap-2">
                      {i === 0 && active && <span className="w-1.5 h-1.5 rounded-full bg-sunkissed" />}
                      {cell}
                      {i === 0 && active && <span className="overline text-[9px] text-sunkissed">You</span>}
                    </span>
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
